var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"inputRef",class:(_vm.customClass + " currencyInput"),attrs:{"type":"text","id":_vm.id,"disabled":_vm.disabled,"placeholder":'0,000'}})}
var staticRenderFns = []

export { render, staticRenderFns }